export default __webpack_public_path__ + "static/podolog-kielce-8d649230f4f9ebc036d4391cd7939c6f.jpg";